import { Controller } from "@hotwired/stimulus"
import { NativeOutbox } from "../native_outbox"
import { intlLocale } from "../lib/intl_locale"
import { interpolate } from "../lib/interpolate"

// Sign-out clears the native outbox (spec §5.4). When it holds items, ask
// first: "N queued items will be deleted". The question must come before the
// sign-out request, because the session is gone by the time the app sees it.
//
// On the sign-out link (data-turbo-method="delete"). Runs before Turbo's own
// click handler, which skips a click whose default was prevented. An existing
// data-turbo-confirm (the anonymous account erase) is folded into the same
// dialog. If the outbox cannot be read, ask anyway with a message without a
// count: the app still deletes whatever it holds. Without the native outbox
// the click goes through untouched.
export default class extends Controller {
  static values = { messages: Object, unreadable: String, locale: String }

  async confirm(event) {
    if (this.confirmed) {
      this.confirmed = false
      return
    }
    if (!NativeOutbox.supported) return

    event.preventDefault()

    let message = null
    try {
      const count = (await NativeOutbox.getOutbox()).items.length
      if (count > 0) message = this.messageFor(count)
    } catch (error) {
      console.warn("Could not read the outbox", error)
      message = this.unreadableValue
    }

    const link = this.element
    const existing = link.dataset.turboConfirm
    if (message) {
      const question = [ existing, message ].filter(Boolean).join("\n\n")
      if (!window.confirm(question)) return

      delete link.dataset.turboConfirm
    }

    this.confirmed = true
    link.click()
    if (existing !== undefined) link.dataset.turboConfirm = existing
  }

  messageFor(count) {
    const form = new Intl.PluralRules(intlLocale(this.localeValue)).select(count)
    const template = this.messagesValue[form] || this.messagesValue.other || ""
    return interpolate(template, { count })
  }
}
